export default __webpack_public_path__ + "static/media/auto-favorito-header.dd7c30f5.svg";